<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="risk_template"
    parentLabel="風險評估"
    parentTitleKey="last_version.name"
    :parentId="$route.params.id"
    :hasCatchVersion="hasCatchVersion"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    hasCatchVersion: true,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "風險評估資訊",
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: [
                "area",
                "area_section",
                "system_class",
                "system_subclass",
              ],
            },
          ],
        },
        // {
        //   type: "infoCard",
        //   floors: [
        //     {
        //       title: "顯示設定",
        //       remark: "隱藏的內容將不會顯示於使用者前台介面",
        //       fields: ["is_active"],
        //     },
        //   ],
        // },
      ],
    },
  }),
};
</script>